<div class="vtr-widget-support">
	<div class="container-fluid">
		<div class="row">
			<div class="col">
				<div class="title" role="text">{{title}}</div>
				<div class="description" role="text">{{description}}</div>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<vtr-ui-list-support [items]="items"></vtr-ui-list-support>
			</div>
		</div>
	</div>
</div>